<template>
 <div class="email-detail">
   <div class="container-fluid">
     <sidebar />
     <div class="col-md-9 col-lg-10 ml-md-auto">
       <div id="scroll" class="header d-flex justify-content-start w-100 align-items-center py-3 mb-5 border-bottom border-dark">
         <h2 class="my-3">メッセージ編集</h2>
       </div>
       <div v-if="emailStatus">
        {{statusAlert(true)}}
       </div>
       <div class="bg-light py-3 px-2 mb-4">
         <b-container fluid>
           <b-form>
             <memberModal v-if="allMember && setMagazine && destinationIDs"
              @insert="insertList"
              @langDestination="insertLanguage"
              @destinationEmail="insertUserDestination"
             />
             <b-form-group label="件名" id="sbject" class="mb-4" v-if="setMagazine">
              <b-col class="p-0">
                <b-form-input class="form-input" v-model="setMagazine.subject"></b-form-input>
              </b-col>
             </b-form-group>

             <b-form-group label="メルマガ本文" id="blog-body" v-if="setMagazine">
                <Editor v-model="setMagazine.body" :api-key="getTinyConfig.api_key"  :init="getTinyConfig.config"/>
              </b-form-group>
           </b-form>
        </b-container>
       </div>
       <div class="justify-content-start align-items-center mb-4" v-if="setMagazine">
         <a href="#scroll" class="text-decoration-none text-white" v-smooth-scroll><b-button class="py-3 px-5 mr-3" variant="primary" @click="draft">下書きとして保存</b-button></a>
         <a href="#scroll" class="text-decoration-none text-white" v-smooth-scroll><b-button class="py-3 px-5" variant="success" @click="save">送信</b-button></a>
         <b-button class="py-3 px-5 float-right pull-right" variant="danger" v-b-modal.modal-delete>削除</b-button>
       </div>
       <b-modal id="modal-delete" ref="modal-delete" class="del-member" hide-footer hide-header centered title="BootstrapVue">
          <h6 class="m-4 text-center">本当に削除してもよろしいですか？</h6>
          <div class="d-flex justify-content-center align-items-center">
            <b-button class="py-3 px-5 mr-3" variant="primary" @click="hideModal">キャンセル</b-button>
            <b-button class="py-3 px-5" variant="danger" v-b-modal.modal-delete @click="deleteMagazine(setMagazine.id)">削除</b-button>
          </div>
        </b-modal>
     </div>
   </div>
 </div>
</template>

<script>
import Editor from '@tinymce/tinymce-vue'
import sidebar from '@/components/_sidebar/sidebar'
import memberModal from './components/email_member_listEdit'
import appConfig from '../../api/api'
import { mapActions, mapState } from 'vuex'

export default {
  data () {
    return {
      users: 'NGユーザーを含む',
      userLanguage: [
        { text: 'NGユーザーを含む', value: 'all' },
        { text: 'NGユーザーのみ', value: 'ng' }
      ],
      error: null,
      response: null,
      selected: []
    }
  },
  components: {
    sidebar,
    memberModal,
    Editor
  },
  computed: {
    ...mapState('latestMember', ['allMember']),
    ...mapState('adminMagazine', ['setMagazine', 'emailStatus', 'destinationIDs']),
    getTinyConfig: function () {
      return appConfig
    }
  },
  created () {
    this.getMagazine(this.$route.params.id)
    this.getAllMember()
    this.$store.commit('adminMagazine/setEmailStatus', null)
  },
  methods: {
    ...mapActions('latestMember', ['getAllMember']),
    ...mapActions('adminMagazine', ['updateMagazine', 'getMagazine', 'deleteEmailMagazine']),
    save: function () {
      if (this.setMagazine.language === 'unselected') {
        const value =
        {
          values: {
            destination_id: this.setMagazine.destination_id,
            language: this.setMagazine.language,
            selected_ng: this.setMagazine.selected_ng,
            subject: this.setMagazine.subject,
            body: this.setMagazine.body,
            published_status: 'sent'
          },
          id: this.$route.params.id
        }
        this.updateMagazine(value)
      } else {
        const value =
        {
          values: {
            language: this.setMagazine.language,
            selected_ng: this.setMagazine.selected_ng,
            subject: this.setMagazine.subject,
            body: this.setMagazine.body,
            published_status: 'sent'
          },
          id: this.$route.params.id
        }
        this.updateMagazine(value)
      }
    },
    draft: function () {
      if (this.setMagazine.language === 'unselected') {
        const value =
        {
          values: {
            destination_id: this.setMagazine.destination_id,
            language: this.setMagazine.language,
            selected_ng: this.setMagazine.selected_ng,
            subject: this.setMagazine.subject,
            body: this.setMagazine.body,
            published_status: 'draft'
          },
          id: this.$route.params.id
        }
        this.updateMagazine(value)
      } else {
        const value =
        {
          values: {
            language: this.setMagazine.language,
            selected_ng: this.setMagazine.selected_ng,
            subject: this.setMagazine.subject,
            body: this.setMagazine.body,
            published_status: 'draft'
          },
          id: this.$route.params.id
        }
        this.updateMagazine(value)
      }
    },
    isDisabled () {
      if (this.setMagazine.language !== 'unselected') {
        return true
      }
    },
    insertList (value) {
      if (this.setMagazine) {
        this.setMagazine.destination_id = value
        this.selected = value
      }
    },
    insertLanguage (value) {
      this.setMagazine.language = value
    },
    insertUserDestination (value) {
      this.setMagazine.selected_ng = value
    },
    deleteMagazine (value) {
      const id = { id: value }
      this.deleteEmailMagazine(id)
    },
    hideModal () {
      this.$refs['modal-delete'].hide()
    },
    statusAlert (append = false) {
      this.$bvToast.toast('body', {
        title: this.emailStatus,
        toaster: 'b-toaster-top-center',
        solid: true,
        appendToast: append,
        autoHideDelay: 3000
      })
    }
  }
}
</script>
